module.exports = __webpack_public_path__ + "img/calendar2-minus-fill.59faf690.svg";